


import React, { useContext, useEffect, useReducer, useState } from "react";
import {  useNavigate } from "react-router-dom";
import {  Button, Modal, Nav, Tab } from "react-bootstrap";
import 'react-datepicker/dist/react-datepicker.css';


import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

import AddVendorModal from "../addAndListOfAllVendors/addVendorModal";
import { getAllVendorApi } from "../../../../service/vendor/getAllVendors";
import AssignedVendorTable from "../assignedVendors/assignedVendorTable";
import AssigningVendorTable from "./assingingVendorTable";
import { addOrUpdatePropertyVendorApi } from "../../../../service/property/addOrUpdatePropertyVendor";
import { getVendorListExcludePropertyApi } from "../../../../service/vendor/getVendorListExcludeProperty";
import { setLoading } from "../../../../feature/authSlice";
const AssigningVendorModal = ({handleModalView,modalView,filterType}) => {
  const {PropertyId,customerId} = useSelector(state => state.auth)
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const[vendorListArr,setVendorListArr] = useState([])
const[apiLoading,setApiLoading] = useState(false)
  const [pageViewVendor, setPageViewVendor] = useState(1);
  const [pageSizeViewVendor, setPageSizeViewVendor] = useState(5);
  const [totalPageViewVendor, setTotalPageViewVendor] = useState(1);
  const [searchValueViewVendor, setSearchValueViewVendor] = useState("");
  const [totalViewVendorCount, setTotalViewVendorCount] = useState(0);
  const [vendorModalView,setVendorModalView] = useState(false)
  const [vendorData,setVendorData] = useState({})
 const [modalType,setModalType] = useState(1)
 const [selectedRows, setSelectedRows] = useState([]);
 const [buttonApiLoading,setButtonApiLoading] = useState(false)
   const { permissionArr } = useSelector((state) => state.auth);
 
  const handleSearchViewVendor = (e) => {
    // pageViewVendor(1)

    setSearchValueViewVendor(e.target.value);
    if (searchValueViewVendor.trim().length >= 2) {
      onChangePageViewVendor(1);
    }
  };

  const handleChangeRowsPerPageViewVendor= (e) => {
    // console.log(e)
    setSearchValueViewVendor("");
    setPageViewVendor(1);
    setPageSizeViewVendor(e.target.value);
  };

  const onChangePageViewVendor = (e, p) => {
    // setPage(p);
    setPageViewVendor(e);
  };
 
  const columns = [
    {
        Header: "  ",
        Footer: "  ",
        accessor: "hjhjj",
      },
    {
      Header: "Vendor Name ",
      Footer: "Vendor Name ",
      accessor: "VendorName",
    },
   
    {
      Header: "Vendor Email",
      Footer: "Vendor Email",
      accessor: "VendorEmail",
    },
    {
      Header: "Vendor Code",
      Footer: "Vendor Code",
      accessor: "VendorCode",
    },
    // {
    //   Header: "Vendor PAN",
    //   Footer: "Vendor PAN",
    //   accessor: "VendorPAN",
    // },
    {
      Header: "Vendor Phone",
      Footer: "Vendor Phone",
      accessor: "VendorPhone",
    },
    { Header: "Vendor Site",
    Footer: "Vendor Site",
    accessor: "VendorSite",

    },

   

  ];

// Find the index of "Vendor Site"
const vendorSiteIndex = columns.findIndex(col => col.accessor === "VendorSite");

// Conditional columns to insert
const additionalColumns =
(filterType === "Telephone" && permissionArr.some((perm) => /telephone/i.test(perm)))||permissionArr.some((perm) => /admin/i.test(perm))
  ? [
      {
        Header: "Customer Account Number",
        Footer: "Customer Account Number",
        accessor: "CustomerAccountNo",
      }
    ]
  : [];

// Insert additional columns before "Vendor Site"
if (vendorSiteIndex !== -1) {
  columns.splice(vendorSiteIndex, 0, ...additionalColumns);
}


  useEffect(()=>{
onLoadData()
  },[pageViewVendor])

  function onLoadData (){
    setApiLoading(true)
    var data ={
      Filter: "IsActive==true",
      OrderBy: "-Id",
      PageSize: pageSizeViewVendor,
      PageNumber: pageViewVendor,
      Keyword: searchValueViewVendor
    }
   var params = {
      propertyId:localStorage.getItem("propId")
    }
    dispatch(getVendorListExcludePropertyApi(data,params,(response)=>{
        setApiLoading(false)
        
        setVendorListArr(response.data.result.List)

        setTotalViewVendorCount(response.data.result.TotalCount);
        if (parseInt(response?.data?.result?.TotalCount) % pageSizeViewVendor === 0) {
          setTotalPageViewVendor(parseInt(response?.data?.result?.TotalCount / pageSizeViewVendor));
        } else {
            setTotalPageViewVendor(
            parseInt(response?.data?.result?.TotalCount / pageSizeViewVendor + 1)
          );
        }
    },(res)=>{
        setApiLoading(false)
        
    }))
  }

  function handleAddVendorModal (type){
    setModalType(type)
    setVendorModalView(!vendorModalView)
    if(vendorModalView){
      onLoadData()
    }
  }
  useEffect(() => {
    let typingTimer;

    // Clear the previous typing timer
    clearTimeout(typingTimer);

    // Set a new typing timer
    typingTimer = setTimeout(() => {
      onLoadData();
    
    }, 1500);

    // Clean up the timer when component unmounts or search values change
    return () => clearTimeout(typingTimer);
  }, [searchValueViewVendor]);

  function handleEditVendor(data){
   //  console.log(data,"Vendor s")
setVendorData(data)
handleAddVendorModal(2)
  }

  function handleAssignOrUpdateVendors(rows) {
    const transformedRows = rows.map(row => ({
      Id: 0,
      PropertyId:localStorage.getItem("propId"),
      VendorId: row.Id
    }));
    setSelectedRows(transformedRows);
    // console.log("Selected Rows: ", transformedRows);
  }

  
  function handleAddOrUpdateVendorApiCall (){
  setButtonApiLoading(true)
dispatch(addOrUpdatePropertyVendorApi(selectedRows,(res)=>{
  handleModalView()
  setButtonApiLoading(false)
  
},(res)=>{
    setButtonApiLoading(false)
    
  
  }))
  }
  return (
    <>


<ToastContainer />

<Modal className="fade" size='lg' show={modalView} centered>
     
        <Modal.Body>
        <div className="row d-flex justify-content-between">
        <div className="row">
        <div className="col-xxl-12">
       
          

            
              <div className="card-header border-0 pb-2 flex-wrap">
                <h4 className="heading me-2">Vendor List</h4>

                {/* <button type="submit" className="btn btn-primary" onClick={()=>{handleAddVendorModal(1)}} >
                   Add Vendor +
                      </button> */}
               
              </div>
            

              <AssigningVendorTable
                      column={columns}
                      rowsArr={vendorListArr}
                 
            showLoading={apiLoading}
                
                   handleChangeRowsPerPagePagination={
                    handleChangeRowsPerPageViewVendor
                  }
                  searchValuePagination={searchValueViewVendor}
                  pageSizePagination={pageSizeViewVendor}
                  handleSearchPagination={handleSearchViewVendor}
                  totalCountPagination={totalPageViewVendor}
                  handleOnChangePagination={onChangePageViewVendor}
                  totalCount={totalViewVendorCount}
                  handleEditVendor={handleEditVendor}
               
                  onSelectedRowsChange={handleAssignOrUpdateVendors}
                    />
               
         
         
         
        </div>
      </div>
      </div>
        </Modal.Body>
        <Modal.Footer>
          <Button

            variant="danger light"
           onClick={handleModalView}
          >
            Close
          </Button>
          <button

            className="btn btn-primary"
disabled={buttonApiLoading || selectedRows.length == 0 }
          onClick={handleAddOrUpdateVendorApiCall}
          >
       {buttonApiLoading ? "Assigning" :"Assign"}   
          </button>
        </Modal.Footer>
      </Modal>


 
    

   {vendorModalView && <AddVendorModal vendorModalView={vendorModalView} handleVendorModalView={handleAddVendorModal} modalType={modalType} vendorData={vendorData}/>}
    
    
    </>
  );
};
export default AssigningVendorModal;
